import React from 'react';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  type: null, // 하단 messageTypes을 참고하여, 자주 사용되는 메세지일 경우 type명으로 dispatch()
  title: 'Title',
  contents: '',
  btn01Name: '취소',
  btn02Name: '확인 ',
};

export const customMsgSlice = createSlice({
  name: 'customMsg',
  initialState,
  reducers: {
    openCustomMsg: (state, action) => {
      const { type, onConfirm, ...customProps } = action.payload;
      // type을 포함하여 호출 시, messageTypes에 정의된 요소들 자동 적용
      const typeProps = type ? messageTypes[type] || {} : {}; // type && messageTypes[type] 이면 messageTypes에서 가져옴
      return {
        ...state,
        isOpen: true,
        ...typeProps,
        ...customProps, // type, onConfirm을 제외한 나머지 props로 덮어쓰기
        type,
        onConfirm,
      };
    },
    closeCustomMsg: () => initialState,
  },
});

export const { openCustomMsg, closeCustomMsg } = customMsgSlice.actions;

export default customMsgSlice.reducer;

/* 자주 사용되는 메세지 (필요 시, 추가하여 사용하기!) */
const messageTypes = {
  CONFIRM_01: {
    title: '확인해 주세요!',
    contents: <>마지막 결재선을 불러오시겠습니까?</>,
    btn01Name: '확인',
  },
  // CANCEL_01: {
  //   title: '작업을 취소하시겠어요?',
  //   contents: <>화면을 나가면 작성한 내용이 저장되지 않습니다.</>,
  //   btn01Name: '아니요',
  //   btn02Name: '나가기',
  // },
  // CANCEL_02: {
  //   title: '수정을 취소하시겠어요?',
  //   contents: <>취소하면 수정한 내용이 저장되지 않습니다.</>,
  //   btn01Name: '아니요',
  //   btn02Name: '수정취소',
  // },
  // DELETE_01: {
  //   title: '확인해 주세요!',
  //   contents: <>삭제하시겠습니까?</>,
  //   btn01Name: '취소',
  //   btn02Name: '삭제',
  // },
};
